import { Theme } from "../../../interfaces";

interface InsightKentFooterProps {
  theme?: Theme;
}

const InsightKentFooter: React.FC<InsightKentFooterProps> = ({ theme }) => {
  return (
    <div
      className={"page-footer"}
      style={{
        backgroundColor: theme?.customization?.primaryColor,
      }}
    >
      <div className="page-footer-text">
        YOUR HOME MAY BE REPOSSESSED IF YOU DO NOT KEEP UP REPAYMENTS ON YOUR
        MORTGAGE The Financial Conduct Authority does not regulate some forms of
        Buy to Let. Insight Financial (Kent) is an appointed representative of
        PRIMIS Mortgage Network, a trading name of First Complete Limited. First
        Complete Limited is authorised and regulated by the Financial Conduct
        Authority. Our Trading address is The Beechwood Centre, 40 Lower Gravel
        Rd, Bromley, BR2 8GPS For our mortgage advice services, we will charge a
        fee of between £187.50 and £375.00. the £187.50 is typically charged for
        an existing client remortgaging with us or the £375.00 is for new
        clients and clients moving house.
      </div>
    </div>
  );
};

export default InsightKentFooter;
